import React from "react";

import styles from "./Toolbox.css";

export default function Toolbox({ children }) {
  return <div className={styles.root}>{children}</div>;
}
